import { render, staticRenderFns } from "./order-status-change.vue?vue&type=template&id=a831f146"
import script from "./order-status-change.vue?vue&type=script&lang=js"
export * from "./order-status-change.vue?vue&type=script&lang=js"
import style0 from "./order-status-change.vue?vue&type=style&index=0&id=a831f146&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports